<template>
  <div class="container">
    <div>
      <div class="title">
        <span>全部应用</span>
        <span :class="currentIndex === 0 ? 'active' : ''" @click="chooseList(-1)">全部</span>
        <span
          :class="currentIndex === index+1 ? 'active' : ''"
          @click="chooseList(index)"
          v-for="(item,index) in ServerTypeList"
          :key="item.typeId"
        >{{item.typeName}}</span>
      </div>
      <el-row style="background:#fff;padding:40px" :gutter="30">
        <el-col class="mgb-40" :span="6" v-for="item in currentList" :key="item.serviceId">
          <a
            class="link"
            @click="linkPage(item)"
            target="_blank"
          >
            <el-row>
              <el-col :span="8">
                <el-image
                  style="width: 80px;height: 80px;border-radius: 10px;"
                  fit="cover"
                  :src="item.url ? item.url : serveUrl"
                  alt
                  @click="goToUrl(item.serviceId)"
                />
              </el-col>
              <el-col :span="16">
                <h2 :title="item.serviceName" class="ellipsis-2">{{item.serviceName}}</h2>
                <p class="ellipsis-3">{{item.serviceDescribe}}</p>
              </el-col>
            </el-row>
          </a>
          <el-button
            round
            size="small"
            @click.stop="removeServer(item.serviceId)"
            v-if="item.isAdd == 1 && item.isInstall != 1"
            icon="el-icon-close"
          >移 除</el-button>
          <el-button
            round
            size="small"
            @click.stop="addServer(item.serviceId)"
            v-if="!item.isAdd && item.isInstall != 1"
            icon="el-icon-plus"
          >添 加</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {getPartnerId} from '@/utils/auth'
export default {
  data() {
    return {
      currentIndex: 0,
      currentTypeId: '',
      serverList: [], // 所有服务列表
      ServerTypeList: [], // 服务类型列表
      currentList: [], // 当前显示的服务列表
      serveUrl: require('@/assets/personalCenter/server.png'),
      autoUrl: require('@/assets/personalCenter/auto2.png'), // 默认标识
      gotoUrl: process.env.VUE_APP_SERVICE_GOTO_URL
    }
  },
  created() {
    this.getServerList()
    this.getServerType()
  },
  methods: {
    linkPage(item){
      if(item.status==2){
        return this.$message.error("暂无此应用")
      }
     // window.location.href = item.serviceId ? `${this.gotoUrl}?serviceId=${item.serviceId}` : ''
      window.open(item.homepageUrl)
    },
    goToUrl(){},
    // 获取所有服务
    getServerList() {
      this.$request({
        method: 'post',
        url: '/api/web/service/page',
        data:{
          page:1,
          limit:999,
          partnerId:getPartnerId(),
          // partnerId:'1306121372718276610',
        }
      }).then(res => {
        this.serverList = res.data.list
        if (this.currentTypeId === '') {
          this.currentList = this.serverList
          console.log(this.currentList)
        } else {
          this.getCurrentList(this.currentTypeId)
        }
      })
    },
    // 获取服务类型
    getServerType() {
      let config = {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
      };
      this.$request({
        method: 'post',
        url: '/api/web/servicetype/list',
        data:{
          ...config,
          partnerId:getPartnerId(),
          // partnerId:'1306121372718276610',
          }
      }).then(res => {
        this.ServerTypeList = res.data
      })
    },
    // 添加服务
    addServer(id) {
      this.$request({
        method: 'post',
        url: '/api/web/userrelservice/save',
        data: {
          serviceId: id
        }
      }).then(() => {
        this.$message({
          type: 'success',
          message: '添加成功!'
        })
        this.getServerList()
      })
    },
    // 移除服务
    removeServer(id) {
      this.$confirm('确认移除当前服务？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$request({
            method: 'post',
            url: '/api/web/userrelservice/deleteUserService',
            data: {
              serviceId: id,
              isInstall: 2
            }
          }).then(res => {
            if (res.code === 0) {
              this.getServerList()
              this.$message({
                type: 'success',
                message: '移除成功!'
              })
            }
          })
        })
        .catch(() => {})
    },
    // 点击显示当前类型
    chooseList(index) {
      this.currentIndex = Number(index) + 1
      if (index == -1) {
        this.currentList = this.serverList
        this.currentTypeId = ''
      } else {
        this.currentTypeId = this.ServerTypeList[index].typeId
        this.getCurrentList(this.currentTypeId)
      }
    },
    getCurrentList(type) {
      this.currentList = this.serverList.filter(item => {
        return item.serviceTypeId === type
      })
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  width: 1440px;
  margin: 0 auto;
  p {
    margin: 0;
  }
  .title {
    margin: 20px 0;
    span {
      color: #666;
      border-radius: 4px;
      &:nth-of-type(1) {
        font-weight: 600;
        font-size: 22px;
        margin-right: 50px;
      }
      &:not(:nth-of-type(1)) {
        display: inline-block;
        padding: 0 12px;
        height: 30px;
        line-height: 28px;
        text-align: center;
        border: 1px solid rgba(183, 183, 183, 1);
        box-sizing: border-box;
        font-size: 14px;
        margin-right: 10px;
        cursor: pointer;
      }
      &.active {
        color: #fff;
        background: rgba(52, 107, 253, 1);
        border: 1px solid rgba(52, 107, 253, 1);
      }
    }
  }
}
.link {
  display: block;
  color: #606266;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 6px;
  height: 140px;
  box-sizing: border-box;
  transition: all 0.15s ease;
  &:hover {
    box-shadow: 4px 4px 10px 3px #f0f0f0;
    transform: scale(1.005);
  }
  h2 {
    margin: 0;
    margin-bottom: 10px;
    font-size: 18px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }
  p {
    font-size: 12px;
    color: #999;
    height: 48px;
    overflow: hidden;
  }
}
.mgb-40 {
  margin-bottom: 30px;
  height: 172px;
}


</style>
